import api from './client';

export const getCableTypes = (projectId) => api.get('/cable-types', { params: { project: projectId } });
export const createCableType = (data) => api.post('/cable-types', data);
export const updateCableType = (id, data) => api.put(`/cable-types/${id}`, data);
export const deleteCableType = (id) => api.delete(`/cable-types/${id}`);
